module.exports = __webpack_public_path__ + "static/media/06.dd35c789.png";